import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export type ConfirmDialogButtonVariant =
  | 'primary'
  | 'theme'
  | 'dark'
  | 'danger'
  | 'link'
  | 'secondary';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  confirmButtonVariant?: ConfirmDialogButtonVariant;
  cancelButtonVariant?: ConfirmDialogButtonVariant;
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData) {}

  get title(): string {
    return this.data?.title;
  }

  get message(): string {
    return this.data?.message;
  }

  get confirmButtonText(): string {
    return this.data?.confirmButtonText;
  }

  get cancelButtonText(): string {
    return this.data?.cancelButtonText;
  }

  get confirmButtonVariant(): ConfirmDialogButtonVariant {
    return this.data?.confirmButtonVariant || 'theme';
  }

  get cancelButtonVariant(): ConfirmDialogButtonVariant {
    return this.data?.cancelButtonVariant || 'secondary';
  }
}
